import { useSelector } from "react-redux";

import { selectInsideAM } from "../selectors";

export function useAmFound() {
  return useSelector(selectInsideAM);
}
